import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { useGetTeamsQuery } from 'store/modules/api/afl-api';
import { leaderboardSelector } from 'common/store/modules/player-awards/leaderboard/selectors/simple-selectors';
import { navSelector } from 'common/store/modules/competition-nav/selectors';
import { setTeam } from 'common/store/modules/player-awards/leaderboard';

export const ClubNavItem = ({ classes }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const leaderboardState = useSelector(leaderboardSelector);
    const { data: [...teamsList] = [] } = useGetTeamsQuery(nav.season.id, {
        skip: !nav.season.id ? true : false
    });

    const teams = [
        { id: -1, name: getTranslation('label.stats.allClubs') },
        ...teamsList.sort((a, b) => a.name.localeCompare(b.name))
    ];

    return (
        <div
            className={`stats-leaders-nav__select competition-nav__competition-select ${
                classes ? classes : ''
            }`}
        >
            <Select
                items={teams}
                itemToString={(team) => team?.name}
                type="with-default"
                icon="guernsey"
                initialSelectedItem={
                    teams.length && leaderboardState.team.id
                        ? teams.find((t) => t.id === leaderboardState.team.id)
                        : ''
                }
                activeItem={
                    teams.length && leaderboardState.team.id
                        ? teams.find((s) => s.id === leaderboardState.team.id)
                        : ''
                }
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        setTeam({
                            team: selectedItem
                        })
                    );
                }}
                isReadyToRender={() => teams?.length}
                label={getTranslation('label.filters.club')}
                hideLabel
                showTeamLogo
            />
        </div>
    );
};

ClubNavItem.propTypes = {
    classes: PropTypes.string
};
